// src/auth/AuthGate.tsx
import { useEffect, useState } from "react";
import type { Session } from "@supabase/supabase-js";
import { getCurrentSession, onAuth } from "../lib/supabase";
import AuthPage from "./AuthPage";

type Props = {
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

export default function AuthGate({ children, fallback }: Props) {
  const [loading, setLoading] = useState(true);
  const [session, setSession] = useState<Session | null>(null);

  useEffect(() => {
    let unsub = () => {};
    (async () => {
      const s = await getCurrentSession();
      setSession(s);
      setLoading(false);
      unsub = onAuth((_ev, ssn) => setSession(ssn));
    })();
    return () => {
      try {
        unsub();
      } catch {
        /* no-op */
      }
    };
  }, []);

  if (loading) {
    return (
      <div style={{ display: "grid", placeItems: "center", minHeight: "60vh" }}>
        {fallback ?? <span style={{ opacity: 0.7 }}>Cargando…</span>}
      </div>
    );
  }

  if (!session) {
    return <AuthPage />;
  }

  return <>{children}</>;
}
